import { render } from "./FieldList.vue?vue&type=template&id=5d76ba7d"
import script from "./FieldList.vue?vue&type=script&lang=js"
export * from "./FieldList.vue?vue&type=script&lang=js"
script.render = render

export default script